import React from "react";
import { useLocation } from "react-router-dom";
import { ArrowLeft } from "react-bootstrap-icons";

const ActivityDescriptionPage = () => {
    const location = useLocation();
    const { activity } = location.state || {};

    return (
        <div
            style={{
                width: "100vw",
                minHeight: "100vh",
                backgroundColor: "#f9f9f9",
                fontFamily: "'Inter', sans-serif",
                display: "flex",
                flexDirection: "column",
            }}
        >
            {/* Back Button */}
            <button
                onClick={() => window.history.back()}
                style={{
                    position: "absolute",
                    top: "20px",
                    left: "20px",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "1.5rem",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    zIndex: 10,
                }}
            >
                <ArrowLeft />
                <span style={{ fontSize: "1rem" }}>Back</span>
            </button>

            {/* Activity Image */}
            {activity?.image && (
                <div
                    style={{
                        width: "100%",
                        height: "50vh",
                        backgroundImage: `url(${activity.image})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        position: "relative",
                    }}
                >
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "rgba(0, 0, 0, 0.4)",
                        }}
                    />
                </div>
            )}

            {/* Floating Title Section */}
            <div
                style={{
                    maxWidth: "800px",
                    margin: "0 auto",
                    padding: "20px",
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    marginTop: "-100px",
                    zIndex: 1,
                    position: "relative",
                    textAlign: "center",
                }}
            >
                <h1
                    style={{
                        fontSize: "2.5rem",
                        fontWeight: "bold",
                        color: "#333",
                    }}
                >
                    {activity?.name}
                </h1>
            </div>

            {/* Activity Description Section */}
            <div
                style={{

                    margin: "20px auto",
                    padding: "20px",
                    borderRadius: "10px",
                }}
            >
                <p
                    style={{
                        fontSize: "1.2rem",
                        lineHeight: "1.8",
                        color: "#555",
                        textAlign: "justify",
                    }}
                >
                    {activity?.description || "No description available for this activity."}
                </p>
            </div>
        </div>
    );
};

export default ActivityDescriptionPage;
